import { type ComponentProps, createElement } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { Text } from '@core/Components/Text'

export const StewardsCommentsStyled = styled.ul({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx2,
  listStyle: 'none',
  margin: 0,
  padding: 0,
})

const StewardsCommentTextBase = styled(Text)({
  lineHeight: 'inherit',
  margin: 0,
})

export const StewardsCommentTextStyled = ({
  as = 'p',
  size = 'sm',
  ...props
}: ComponentProps<typeof StewardsCommentTextBase>) =>
  createElement(StewardsCommentTextBase, { as, size, ...props })
